<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'words',
})
</script>
<template>
  <a-card title="分类字典">
    <template #extra>
     <a-button  type="primary"   @click="add(0)" ><PlusOutlined /> 添加</a-button>
    </template>
<a-table rowKey="id" :dataSource="dataSource" :pagination="false" :columns="columns" :rowExpandable="true" childrenColumnName="child">
    <template #bodyCell="{ column, text, record }">
      <template v-if="column.key=='action'">
        <a-button-group>
        <a-button   size="small" @click="add(record.id)" v-if='record.pid==0'><PlusOutlined /> 添加</a-button>
         <a-button type="primary" size="small" @click="edit(record)"><EditOutlined /> 修改</a-button>

         <a-button danger type="primary" size="small" v-if="record.child.length==0"  @click="del(record)"> <DeleteOutlined />删除</a-button>
         </a-button-group>
      </template>
    </template>
  </a-table>

  </a-card>

  <lanseed-form v-model:open="open" :data="model" :rules="rules" @change="submit"></lanseed-form>
</template>
<script setup lang="ts" name="words">
import { onMounted ,ref} from 'vue'
import api from '@/utils/http/service'
import { PlusOutlined,EditOutlined,DeleteOutlined } from '@ant-design/icons-vue'
import lanseedForm from '@/components/lanseed/form.vue'
import {message} from 'ant-design-vue'
const columns:Record<string,string>[]=[
  {title:'名称',key:'text',dataIndex: 'text',},
  {title:'引用标识',key:'sub',dataIndex: 'sub',},
  {title:'',key:'action'}
]
const dataSource:Record<string,string>[]=ref([])
const model:Record<string,string>=ref({})
const rules={
  title:{name:'名称',required:true},
  cname:{name:'标识',desc:'系统引用的标识名称，使用字母'},
  ordernum:{name:'排序',type:'number'}
}
onMounted(()=>{
  getDataList()
})
const open=ref<boolean>(false)

const getDataList=():void=> {
      let p = { pageFlag: false }
      api.words.list(p).then(res => {
        if (res.state == 1) {
          dataSource.value = res.data
        }
      })
    }
const add=(pid:number):void=>{
  model.value={ID:0,pid:pid,title:'',cname:'',ordernum:0}
  open.value=true
}
const submit=(d):void=>{

 if (d.title == "") {
        message.error('标题不可为空')
        return false
      }
      if (d.cname == '' && d.pid == 0) {
        message.error('标识用于取子集数据，不可为空')
        return false
      }
      api.words.add(d).then(res => {
        if (res.state == 1) {
           open.value=false
           getDataList()
        }
      })
}
const edit= (item:Record):void=> {

        api.words.get({ id: item.id }).then(res => {
          if (res.state == 1) {
            model.value= res.data
            open.value=true
          }
        })
    }

const del=(item:Record):void=> {
        api.words.del({ id: item.id }).then(res => {
          if (res.state == 1) {
             message.success(res.message)
             getDataList()
          }
        })
    }

</script>
